import React, { useEffect, useMemo } from 'react';
import { Infobox, Loader } from 'ui-library';
import { useNavigate, useParams } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import { withCSContext } from 'services/ApolloClient';
import { useSelector } from 'react-redux';
import { memberIdSelector } from 'redux-store/auth/authSelectors';
import { generateDFSClientId } from '../../../utils';

const EXTERNAL_CLIENT_INFORMATION = gql`
    query ClientInformation($extZkpId: String!) {
        contacts(
            where: { relationshipInformation: { extZkpId: { eq: $extZkpId } } }
        ) {
            items {
                id
                relationshipInformation {
                    extZkpId
                }
            }
        }
    }
`;

export const ClientLanding = () => {
    const navigate = useNavigate();
    const { externalClientId } = useParams();
    const memberId = useSelector(memberIdSelector);
    const context = useMemo(() => (withCSContext({ queryParams: { memberId } })), [memberId]);

    const {
        loading: isLoading,
        error,
        refetch,
    } = useQuery(EXTERNAL_CLIENT_INFORMATION, {
        variables: { extZkpId: externalClientId },
        skip: true,
        context,
    });

    useEffect(() => {
        if (externalClientId) {
            (async () => {
                try {
                    const response = await refetch();
                    const clientId = response?.data?.contacts?.items?.[0]?.id;

                    const dfsClientId = clientId && generateDFSClientId(clientId);

                    if (dfsClientId) {
                        navigate(`/client/${dfsClientId}`);
                    } else {
                        navigate('/onboardingflow/newPersonalInformation', {
                            state: { externalClientId },
                        });
                    }
                } catch (err) {
                    if (err?.response?.status === 404) {
                        navigate('/onboardingflow/newPersonalInformation', {
                            state: { externalClientId },
                        });
                    }
                }
            })();
        }
    }, [externalClientId]);

    return isLoading ? <Loader /> : error && <Infobox error>{error?.message || ''}</Infobox>;
};
